import React from 'react';
import styles from './Resumo.module.css';
import { useTranslation } from "react-i18next";
import { useCalculateWithFee } from '../../../utils/fee';
import { useFee } from '../../../context/FeeContext';

interface ResumoDoPedidoProps {
  produtos: {
    name: string;
    quantity: number;
    quantidadePedido: number;
    originalPrice: number;
    promotionalPrice?: number;
  }[];
  voucher: {
    name: string;
    discount: number;
    valid: boolean;
  };
  freight?: number
}

const ResumoDoPedido: React.FC<ResumoDoPedidoProps> = ({ produtos, voucher, freight }) => {
  const { fee } = useFee()
  const calcWithFee = useCalculateWithFee()
  const totalSemDesconto = produtos.reduce((acc, produto) => acc + ((produto.promotionalPrice ?? produto.originalPrice) * produto.quantidadePedido), 0);
  const totalSemDescontoComTaxa = totalSemDesconto + ((fee / 100) * totalSemDesconto)


  const totalComDesconto = voucher.valid
    ? (totalSemDescontoComTaxa + (freight ?? 0)) * (1 - voucher.discount / 100)
    : totalSemDescontoComTaxa + (freight ?? 0);

  const { t } = useTranslation();
  return (
    <div className={styles.resumo_geral}>
      {produtos.map(produto => (
        <div key={produto.name}>
          <div className={styles.atributos}>
            <div className={styles.nome}>
              <p>{produto.name}</p>
            </div>
            <div className={styles.quantidade}>
              <p>{produto.quantidadePedido}x</p>
            </div>
            <div className={styles.preco}>
              <p>R$ {(produto.promotionalPrice ? calcWithFee(produto.promotionalPrice * produto.quantidadePedido) : calcWithFee(produto.originalPrice * produto.quantidadePedido))}</p>
            </div>
          </div>
        </div>
      ))}
      {freight !== undefined && <div>
        <div className={styles.atributos}>
          <div className={styles.nome}>
            <p>{t("resumo.freight")}</p>
          </div>
          <div className={styles.preco}>
            <p>R$ {(freight).toFixed(2)}</p>
          </div>
        </div>
      </div>}
      <div className={styles.totalgeral}>
        <p className={styles.escrita}>{t("resumo.totalgeral")}</p>

        {voucher.valid && (
          <p className={styles.desconto}>
            R$ {totalComDesconto.toFixed(2)}
          </p>
        )}
        <p className={voucher.valid ? styles.PrecoRiscado : styles.numero}>
          R$ {(totalSemDescontoComTaxa + (freight ?? 0)).toFixed(2)}
        </p>
      </div>
    </div>
  );
};

export default ResumoDoPedido;
